import { AnalyticsComponent } from './analytics.component';

export const PAGES = [
  AnalyticsComponent,
];

export * from './analytics.component';
